/* eslint-disable no-magic-numbers */
import axios from 'axios';
import _ from 'lodash';
import NProgress from 'nprogress';
import { Message } from 'element-ui';
import { logout } from './index';
import bigDataLog from '@/utils/bigDataLog';
import config from '../config/user.env';
import store from '../store';

// 已独立化改造的服务
const ANNTO_PREFIXS = ['/api-xxx'];
// 独立化改造新接口域名
const ANNTO_REQ_DOMAIN = {
    SIT: 'https://anapi-sit.annto.com',
    UAT: 'https://anapi-uat.annto.com',
    VER: 'https://anapi-ver.annto.com',
    PROD: 'https://anapi.annto.com'
};

axios.defaults.timeout = 60000 * 30; // 请求超时时间
axios.defaults.withCredentials = true;
axios.defaults.baseURL = config.apiUrl;

// request拦截器
axios.interceptors.request.use(reqConfig => {
    NProgress.start();
    const currentTenant = store.state.currentTenant;
    const tenantCode = currentTenant ? currentTenant.tenantCode : null;
    if (tenantCode) {
        reqConfig.headers['tenantCode'] = tenantCode;
    }
    // 根据接口是否已完成改造来判断使用新接口域名
    const isAnntoPrefix = ANNTO_PREFIXS.some(prefix => reqConfig.url.includes(prefix));
    reqConfig.baseURL = isAnntoPrefix ? ANNTO_REQ_DOMAIN[config.env] : config.apiUrl;
    // 过滤get请求的空参数（null, undefined, ''）
    reqConfig.params = _.chain(reqConfig).get('params').toPairs().filter(arr => !_.isNil(arr[1]) && arr[1] !== '').fromPairs().value();
    return reqConfig;
}, error => {
    NProgress.done();
    Promise.reject(error);
});
const CUSTOM_ERROR_CODES = ['LSRM-AI001', 'LSRM-AI002', 'LSRM25081402'] // 特殊的报错code，用于自定义报错

// respone拦截器
axios.interceptors.response.use(
    response => {
        NProgress.done();
        if (response.data && response.data.code === 403) {
            logout();
        }  else if (response.data && response.data.code && CUSTOM_ERROR_CODES.includes(response.data.code)) {
            return response.data;
        } else if (response.config.isBypassErrHandling && response.data && response.data.code && response.data.code !== '0' && response.data.code !== 200) {
            return response.data;
        } else if (response.data && response.data.code && response.data.code !== '0' && response.data.code !== 200) {
            // 200 为了 oss 接口添加
            Message.error({
                message: ['', 'Success'].includes(response.data.msg) ? response.data.errMsg : response.data.msg,
                showClose: true
            });
            bigDataLog.sendErrorMessage({
                errContent: '接口出错了',
                errType: 'BackEndError'
            });
            window._paq && window._paq.push(['trackEvent', 'BackEndError', 'error', response.data.msg]);
        } else {
            return response.data;
        }
    },
    error => {
        NProgress.done();
        const response = Object.assign({}, error.response);
        if (response) {
            switch (response.status) {
            case 400:
                Message.error('请求出现错误');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '400']);
                break;
            case 401:
                Message.closeAll();
                Message.error('你还没有登录呦！');
                logout();
                break;
            case 403:
                Message.error('请求资源被拒绝');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '403']);
                break;
            case 404:
                Message.error('没找接口信息');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '404']);
                break;
            case 405:
                Message.error('请求方法不支持');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '405']);
                break;
            case 500:
                Message.error('系统异常');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '500']);
                break;
            case 502:
                Message.error('网关错误');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '502']);
                break;
            case 503:
                Message.error('服务不可用');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '503']);
                break;
            case 504:
                Message.error('网关超时');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', '504']);
                break;
            default:
                Message.error('网络波动请重试，若重试后还有问题请联系IT5000');
                window._paq && window._paq.push(['trackEvent', 'NetworkError', 'error', response.status + '']);
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
